// <pfs-toast-trigger>: deklaratives Server-rendered Toast-Triggering.
//
// Use-case: server-side Templates (Go-Templ, PHP, Razor, …) wollen bei
// einem Page-Load einen Toast anzeigen — ohne eigenes inline-script.
// Das WC tut genau das beim connect: dispatcht `pfs:toast` an den
// document.body, sobald `<pfs-toast-host>` existiert. Self-cleanup
// (entfernt sich nach dispatch).
//
// Beispiel (Server-rendered):
//   <pfs-toast-trigger
//       data-title="Anmeldung fehlgeschlagen"
//       data-message="Ungültige Zugangsdaten"
//       data-variant="error"
//       data-duration="5000"></pfs-toast-trigger>
//
// Browser-Pattern fuer JS-Code: NICHT toast-trigger nutzen — direkt
// `document.body.dispatchEvent(new CustomEvent("pfs:toast", {...}))`.
//
// Attribute (alle data-*):
//   data-message     required — Toast-Body
//   data-title       optional — fett ueber dem message
//   data-variant     "info" | "success" | "warning" | "error" (default "info")
//   data-duration    ms, "0" = sticky (default 4500 — vom toast-host)
//
// Self-cleanup: Element entfernt sich selbst aus dem DOM nachdem der
// Event dispatched wurde. So bleibt der Server-Render unaufgeräumt
// nicht zurück.

import { defineComponent } from "../../composition/define-component.js";

defineComponent({
  tagName: "pfs-toast-trigger",
  // Kein Shadow-Root — das WC ist invisible, dient nur als Event-
  // Dispatcher.
  render(host) {
    const message = host.dataset.message;
    if (!message) {
      // Defensiv: ohne message kein Toast (Spec von pfs-toast-host).
      host.remove();
      return;
    }
    const detail: Record<string, unknown> = { message };
    if (host.dataset.title) detail.title = host.dataset.title;
    if (host.dataset.variant) detail.variant = host.dataset.variant;
    if (host.dataset.duration) {
      const n = Number(host.dataset.duration);
      if (!Number.isNaN(n)) detail.duration = n;
    }

    // pfs-toast-host kann VORHER, NACHHER oder NIE registriert werden.
    // whenDefined awaited bis dahin — bei NIE bleibt das Promise pending,
    // kein Memory-Leak weil das Element sich selbst entfernt sobald
    // disposed.
    customElements.whenDefined("pfs-toast-host").then(() => {
      // Re-check: bei sehr schnellem Disconnect könnte host bereits weg sein
      if (!host.isConnected) return;
      document.body.dispatchEvent(
        new CustomEvent("pfs:toast", {
          detail,
          bubbles: true,
          composed: true,
        }),
      );
      host.remove();
    });
  },
});
